import { render, staticRenderFns } from "./BuilderFrame.vue?vue&type=template&id=3fca1d14&"
import script from "./BuilderFrame.vue?vue&type=script&lang=js&"
export * from "./BuilderFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports